import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { ReelsFeed } from "../components/ReelsFeed";

const Search = () => {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [videos, setVideos] = useState(null);

  useEffect(() => {
    setVideos(null);
    api.get(`/videos?search=${encodeURIComponent(q)}`).then((r) => setVideos(r.data)).catch(() => setVideos([]));
  }, [q]);

  return (
    <div className="relative">
      <div className="absolute top-0 left-0 right-0 z-30 bg-gradient-to-b from-black/80 to-transparent pt-3 pb-6 px-4">
        <p className="text-xs uppercase tracking-[0.2em] text-zinc-400">Results for</p>
        <p className="font-display text-lg text-[#FFD60A]">"{q}"</p>
      </div>
      {videos === null ? (
        <div className="h-[calc(100vh-6.5rem)] flex items-center justify-center text-zinc-500">Searching…</div>
      ) : (
        <ReelsFeed key={q} videos={videos} emptyText={`No matches for "${q}".`} />
      )}
    </div>
  );
};

export default Search;
